/**
 * Ендпоинт получения инвайтов компании.
 *
 * @type {string} Id Компании
 */
const companyInviteEndpoint = 'company/{companyId}/invite/'

/**
 * Эндопоинт обновления инвайтов компании.
 *
 * @type {string} Email инвайта.
 */
const updateInviteEndpoint = 'invite/{email}'

const confirmRegistration = 'confirm-registration/{hash}'
const userActivated = 'user-activated'

/**
 * Класс для работы с инвайтами
 */
export class InviteRepository {
    /**
     * Конструктор
     *
     * @param ApiService Сервис доступа к API
     */
    constructor (ApiService) {
        this.api = ApiService
    }

    /**
     *
     * @param hash
     * @param isSuccess
     * @returns {Promise<*>}
     */
    async confirmRegistration (hash, isSuccess) {
        return this.api.post(confirmRegistration.replace('{hash}', hash), { isSuccess })
    }

    async changePassword (formData) {
        return this.api.post(userActivated, formData)
    }

    /**
     * Получить все инвайты по id компании
     *
     * @param companyId id компании
     *
     * @returns {Promise<*>}
     */
    async findAllInviteByCompanyId (companyId) {
        return this.api.get(companyInviteEndpoint.replace('{companyId}', companyId))
    }

    /**
     * Обновить инвайт по его email
     *
     * @param email email инвайта который обновляем
     *
     * @returns {Promise<*>}
     */
    updateInviteByEmail (email) {
        return this.api.put(updateInviteEndpoint.replace('{email}', email))
    }
}
